import {
  getWebsitePageContentIdFromPlaceholder,
  isWebsitePageUrlPlaceholderValue,
} from 'common/utils/website-replacements-utils'

interface MenuItemWithSubItems<SubItem extends { link: string }> {
  link: string
  subMenuItems?: SubItem[]
}

export const removeWebsiteMenuItemsByPageContentIds = <
  SubItem extends { link: string },
  MenuItem extends MenuItemWithSubItems<SubItem>,
>(
  menuItems: MenuItem[],
  deletedPageContentIds: number[],
): MenuItem[] => {
  if (!deletedPageContentIds.length) {
    return menuItems
  }

  const isRemovedPageLink = (link: string) => {
    if (!isWebsitePageUrlPlaceholderValue(link)) {
      return false
    }

    const pageContentId = getWebsitePageContentIdFromPlaceholder(link)

    return (
      pageContentId !== null && deletedPageContentIds.includes(pageContentId)
    )
  }

  return menuItems
    .filter(item => !isRemovedPageLink(item.link))
    .map(item => ({
      ...item,
      subMenuItems: item.subMenuItems?.filter(
        subItem => !isRemovedPageLink(subItem.link),
      ),
    }))
}
